import intlLocale from './intlLocale';

const formatPercentage = (value, minDigits = 0, maxDigits = 2) => {
  return new Intl.NumberFormat(intlLocale(),
    { style: 'percent', minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits}
  ).format(value);
};

export default formatPercentage;
